const initialState = {
  allFiles: [],
  getallFiles: [],
  savedSummary: null,
  error: null
};

const CSVImportReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SAVE_CSV_FILE_SUCCESS':
      return { 
        ...state, 
        savedSummary: action.payload, 
        allFiles: action.requestData || [], 
        error: null 
      };

     case 'GET_ALL_CSV_FILES_SUCCESS':
      return { 
        ...state, 
        getallFiles: Array.isArray(action.payload?.data)
          ? action.payload.data 
          : Array.isArray(action.payload)
          ? action.payload
          : [], 
        error: null 
      };

    case 'GET_ALL_CSV_FILES_FAILURE':
    case 'SAVE_CSV_FILE_FAILURE':
      return { ...state, error: action.payload };

    default:
      return state;
  }
};

export default CSVImportReducer;
